import CmpRadioListInfo from "./CmpRadioListInfo";

export default CmpRadioListInfo;